import React from "react";
import { Button, Form, Flex, Input, Row, Col } from "antd";
import { useForm } from "antd/es/form/Form";
import { useAppDispatch } from "../redux/hooks";
import { voucherFromQuote } from "../redux/apiActions/requestsAction";
import useUser from "../hooks/useUser";

type Props = {
  record: any;
  popup: any;
};

const ATCVoucherFromQuoteForm: React.FC<Props> = ({ record, popup }: Props) => {
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const { user } = useUser();

  const onFinish = async (values: any) => {
    if (user) {
      await dispatch(
        voucherFromQuote({
          atc_id: user.atc.id,
          data: { ...values, request_id: record.id },
        })
      );
      popup.close();
    }
  };

  return (
    <>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col span={12}>
            <Form.Item
              label="Payment ID"
              name="payment_id"
              rules={[{ required: true, message: "Payment ID is required" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Invoice No"
              name="invoice_number"
              rules={[{ required: true, message: "Invoice No is required" }]}
            >
              <Input />
            </Form.Item>

            <Flex justify={"center"}>
              <Form.Item>
                <Button htmlType="submit">Submit</Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ATCVoucherFromQuoteForm;
